import { Control } from "react-hook-form";

import VehicleCascadeFilterFields from "@/main/components/shared/vehicleCascadeFilterFields/vehicleCascadeFilterFields";
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import { getTranslateByKey } from "@/main/services/utils";
import ContainerBox from "../../../components/containerBox/containerBox";

import * as S from "../styles";
import { ICreateOrderForm } from "../stepOneScreen";

interface IVehicleInformation {
	control: Control<ICreateOrderForm, any>;
	guidCountryToSelect?: string | null;
	hasItemsOfCarts: boolean;
	integration: boolean;
	isEditQuote: boolean;
	isQuoteCanceled?: boolean;
}
function VehicleInformation({
	control,
	guidCountryToSelect,
	hasItemsOfCarts,
	integration,
	isEditQuote,
	isQuoteCanceled = false,
}: IVehicleInformation) {
	const isVehicleSectionDisabled = hasItemsOfCarts || isQuoteCanceled || isEditQuote;

	return (
		<ContainerBox title={getTranslateByKey("information.vehicleInformation")}>
			<S.RowInputsVehicleFilter>
				<VehicleCascadeFilterFields
					idPrefix="id-createOrder"
					isRequired={true}
					isDisabled={isVehicleSectionDisabled}
					showVehicleSearch
					guidCountryToSelect={guidCountryToSelect}
				/>
			</S.RowInputsVehicleFilter>
			<S.RowInputsVehicleInformation>
				<KogInputTextControlledNew
					id="id-createOrder-inputText-licensePlate"
					label={getTranslateByKey("information.licensePlate")}
					name="licensePlate"
					control={control}
					controllerProps={{ rules: { required: false, maxLength: 200 } }}
					disabled={integration || isQuoteCanceled}
				/>
				<KogInputTextControlledNew
					id="id-createOrder-inputText-vin"
					label={getTranslateByKey("information.vin")}
					name="vin"
					control={control}
					disabled={integration || isQuoteCanceled}
				/>
				<KogInputTextControlledNew
					id="id-createOrder-inputText-vehicleColor"
					label={getTranslateByKey("information.vehicleColor")}
					name="vehicleColor"
					control={control}
					disabled={integration || isQuoteCanceled}
				/>
				<KogInputTextControlledNew
					id="id-createOrder-inputText-numbersOfDoor"
					label={getTranslateByKey("information.numbersOfDoor")}
					hasOnlyNumber
					name="numbersOfDoor"
					control={control}
					disabled={integration || isQuoteCanceled}
				/>
			</S.RowInputsVehicleInformation>
		</ContainerBox>
	);
}

export default VehicleInformation;
